import React from 'react';
import styles from './DocumentUploadPage.module.scss';
import { Heading, Text } from '../../../components/Typography';
import DocumentUploadForm from './components/DocumentUploadForm';

const DocumentUploadPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Heading level={1}>Admin Document Upload</Heading>
        <Text>
          Upload company documents by selecting a company, category, type, and PDF files. Enter
          required metadata for each file. Only platform admins can access this page.
        </Text>
      </div>
      <DocumentUploadForm />
    </div>
  );
};

export default DocumentUploadPage;
